// TODO: https://haventech.atlassian.net/browse/HL-54542
// remove this class and its schema.json entries completely
import { Supertype, supertypeClass, property, remote, Remoteable, Persistable } from '@haventech/amorphic';
import { Customer } from './Customer';

/**
 * Represents a potential account, where a customer has specified an email whether
 * on a newsletter or blog or is contacting us with some questions but has not created
 * an account yet.
 * Once an account is created, the customer pointer will be updated if the email is
 * already present, otherwise a new EmailLead will be created
 */
@supertypeClass({ toClient: true, toServer: true })
export class EmailLead extends Remoteable(Persistable(Supertype)) {
  @property({ toServer: false })
  email: string;

  @property({ toServer: false })
  channel: string;

  @property({ toServer: false })
  source: string;

  @property({ toServer: false })
  marketingSource: string;

  @property({ getType: () => Customer })
  customer: Customer;

  constructor() {
    super();
  }

  static new(email?: string) {
    return new EmailLead().init(email);
  }

  init(email?: string) {
    this.email = email;
    return this;
  }
}
